<template>
    <LinkBlockHighlight
        :header="header"
        :background="background"
        :image="image"
        :link="link"
        :text="text"
        :narrow="blockWidth === 'content'"
    />
</template>

<script>
import { get } from 'lodash-es';

export default {
    props: {
        content: {
            type: Object,
            required: true,
            default: () => { return {}; }
        }
    },
    computed: {
        background() {
            return get(this, 'content.backgroundColorLight', '');
        },
        blockWidth() {
            return get(this, 'content.blockWidth', 'default');
        },
        header() {
            return get(this, 'content.header', '');
        },
        text() {
            return get(this, 'content.richTextSimple', '');
        },
        image() {
            return get(this, 'content.image.0', {});
        },
        link() {
            return get(this, 'content.linkSingle.0', {});
        }
    }
};
</script>
